import React, { useEffect, useState } from 'react';
import './Toast.css';

export interface ToastMessage {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  duration?: number;
}

interface ToastProps {
  message: ToastMessage;
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ message, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation on mount
    setIsVisible(true);

    // Auto close after duration
    const timer = setTimeout(() => {
      handleClose();
    }, message.duration || 3000);

    return () => clearTimeout(timer);
  }, [message.duration]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => onClose(message.id), 300);
  };

  const getIcon = () => {
    switch (message.type) {
      case 'success': return 'icon-check';
      case 'error': return 'icon-error';
      case 'warning': return 'icon-warning';
      case 'info': return 'icon-info';
      default: return 'icon-info';
    }
  };

  return (
    <div className={`toast toast-${message.type} ${isVisible ? 'toast-show' : 'toast-hide'}`}>
      <span className="toast-icon">{getIcon()}</span>
      <span className="toast-message">{message.message}</span>
      <button className="toast-close" onClick={handleClose} aria-label="Close">
        <span className="icon-close"></span>
      </button>
    </div>
  );
};

export default Toast;
